import React from 'react';

import { Flex, Typography } from "@app/ui";
import { Client } from "@app/types/api";

type ClientHeaderProps = {
    client: Client;
    title: string;
};

export const ClientHeader = ({ client, title }: ClientHeaderProps) => {
    return (
        <Flex style={{ marginBottom: '1rem' }} vertical>
            <Flex
                justify="flex-start"
                align="center"
                gap={32}
                style={{
                    height: '88px',
                    paddingBottom: 16,
                    marginBottom: '24px',
                    borderBottom: '1px solid rgba(191, 191, 191, 0.5)'
                }}
            >
                <img
                    src={client.headerImageUrl}
                    alt={`${client.name} logo`}
                    style={{
                        height: '72px',
                        width: 'auto',
                        objectFit: 'contain',
                        maxWidth: '200px',
                    }}
                />
                <Typography.Text
                    className="-ellipsis"
                    style={{
                        margin: 0,
                        fontSize: 30,
                        fontWeight: 500,
                    }}
                >
                    {client.name}
                </Typography.Text>
            </Flex>
            <Typography.Title
                level={5}
                style={{
                    color: '#1f1f1f',
                    fontWeight: 600,
                    fontSize: '1rem',
                    lineHeight: '1.5rem'
                }}
            >
                {title}
            </Typography.Title>
        </Flex>
    );
};